export default __webpack_public_path__ + "static/media/Asset---1.0a77dfa7.png";